import { put, call } from 'redux-saga/effects';
import { vendorCreateAPI, vendorInvoiceSearchAPI, vendorSearchAPI, vendorUpdateAPI } from 'src/api/VendorApi';
import { SEARCH_RECORD_PAGE_LIMIT } from 'src/constants/CommonConstants';
import { headerShowAction } from 'src/containers/header-container/actions/HeaderActions';
import { takeFirstSagaUtil } from 'src/utils/ReduxSagaUtils';
import { VENDOR_ACTIONS } from '../actions/VendorActions';
import { toast } from 'react-toastify';

function* search({
    where, currentPage = 0, autopopulate = true, fullTextSearch = true,
} = {}) {
    try {
        const {
            data: {
                data,
            },
        } = yield call(vendorSearchAPI, {
            where,
            pageLength: SEARCH_RECORD_PAGE_LIMIT,
            currentPage,
            autopopulate,
        });

        yield put({
            type: VENDOR_ACTIONS.VENDOR_SEARCH_SUCCESS,
            data,
        });

        return data;
    }
    catch (error) {
        console.error('LOG: function*search -> error', error);
        yield put({
            type: VENDOR_ACTIONS.VENDOR_SEARCH_ERROR,
        });
        return null;
    }
}
function* searchInvoice({
    where, currentPage = 0, autopopulate = true, fullTextSearch = true,
} = {}) {
    try {
        const {
            data: {
                data,
            },
        } = yield call(vendorInvoiceSearchAPI, {
            where,
            pageLength: SEARCH_RECORD_PAGE_LIMIT,
            currentPage,
            autopopulate,
        });

        yield put({
            type: VENDOR_ACTIONS.VENDOR_INVOICE_SEARCH_SUCCESS,
            data,
        });

        return data;
    }
    catch (error) {
        console.error('LOG: function*search -> error', error);
        yield put({
            type: VENDOR_ACTIONS.VENDOR_INVOICE_SEARCH_ERROR,
        });
        return null;
    }
}

function* edit({
    _id,
}) {
    try {
        const {
            data: {
                data: {
                    data,
                },
            },
        } = yield call(vendorSearchAPI, {
            where: {
                _id,
            },
            autopopulate: false,
        });

        if (!data || !data[0]) {
            
            yield put(headerShowAction({
                data: 'Unable to Edit, something when wrong',
            }));
        }

        
        yield put({
            type: VENDOR_ACTIONS.VENDOR_UPSERT_SUCCESS,
            data: data[0],
        });
    }
    catch (error) {
        console.error('LOG: error', error);

        yield put(headerShowAction({
            data: error.response.data.data,
        }));

        yield put(headerShowAction({
            data: error.response.data.data,
        }));
    }
}

function* insert(payload) {
    try {
        const {
            data: {
                data,
            },
        } = yield call(vendorCreateAPI, payload);

        yield put(headerShowAction({
            data: 'Created',
        })); 
        toast("Vendor Created")
        
        yield put({
            type: VENDOR_ACTIONS.VENDOR_UPSERT_SUCCESS,
            data: {
                ...payload,
                _id: data._id,
            },
        });
        yield put({
            type: VENDOR_ACTIONS.VENDOR_SEARCH
        });
    }
    catch (error) {
        console.error('LOG: upsert error', error);
        yield put(headerShowAction({
            data: error.response.data.data,
        }));

        yield put({
            type: VENDOR_ACTIONS.VENDOR_UPSERT_ERROR,
        });
    }
}

function* update(vendorId, payload) {
    try {
        yield call(vendorUpdateAPI, {
            vendorId,
            data: payload,
        });

        yield put(headerShowAction({
            data: 'Updated',
        }));
        if(payload.deleted===true){
            toast("Vendor deleted")
        }
        else{
            toast("Vendor updated")
        } 
        
        yield put({
            type: VENDOR_ACTIONS.VENDOR_SEARCH
        });
    }
    catch (error) {
        console.error('LOG: upsert error', error);
        yield put(headerShowAction({
            data: error.response.data.data,
        }));

        yield put({
            type: VENDOR_ACTIONS.VENDOR_UPSERT_ERROR,
        });
    }
}

function* upsert({
    _id,
    ...payload
}) {
    if (_id) {
        yield update(_id, payload);
    }
    else {
        yield insert(payload);
    }
}

export default [
    takeFirstSagaUtil(VENDOR_ACTIONS.VENDOR_SEARCH, search),
    takeFirstSagaUtil(VENDOR_ACTIONS.VENDOR_INVOICE_SEARCH, searchInvoice),
    takeFirstSagaUtil(VENDOR_ACTIONS.VENDOR_UPSERT, upsert),
    takeFirstSagaUtil(VENDOR_ACTIONS.VENDOR_EDIT, edit),
];
